import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import { useEffect, useState } from "react";
import WelcomeScreen from "./WelcomeScreen";
import DragAndDropScreen from "./DragAndDropScreen";
import apiService from "./apiService";
import logo from "./logo.png";

const lang_texts = {
  hu: {
    LAST_PHASE:
      "Add meg az adataid és küldd el a kitöltésedet kiértékelésre. Létező e-mail címet adj meg, mert az eredményt ide fogod megkapni.",
    NEXT: "Következő oldal",
    SUBMIT: "Küldés",
    NAME: "Név",
    EMAIL: "E-mail",
    GOODBYE: "Köszönjük, megkaptuk a kitöltésed, hamarosan keresni fogunk.",
    WARNING: "Kérlek tegyél a helyére minden szót, hogy a következő oldalra léphess."
  },
  en: {
    LAST_PHASE:
      "Provide your details and send your completed form for evaluation. Please provide a valid email address, as you will receive the results there.",
    NEXT: "Next",
    SUBMIT: "Submit Form",
    NAME: "Name",
    EMAIL: "E-mail",
    GOODBYE: "Thank you for your submission, we are going to contact you shortly.",
    WARNING: "Please put every word in its place so you can move on to the next page."
  },
};

const UrlParams = new URLSearchParams(window.location.search);
const lang = UrlParams.get("lang") || "hu";

function App() {
  const [page, setPage] = useState("welcome");
  const [words, setWords] = useState(null);
  const [rawWords, setRawWords] = useState(null);
  const [result, setResult] = useState([]);
  const [done, setDone] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    initProject();
  }, []);

  const initProject = async () => {
    const UrlParams = new URLSearchParams(window.location.search);
    const lang = UrlParams.get("lang") || "hu";
    const words = await apiService.getWords(lang);
    setRawWords(words);

    const values = ["REG", "THE", "AES", "ECO", "IND", "ALT", "POL"];
    const map = {};

    // Categorize words into arrays
    words.forEach((word) => {
      const valueIndex = values.indexOf(word.value);
      if (valueIndex !== -1) {
        if (!map[word.value]) map[word.value] = [];
        map[word.value].push(word);
      }
    });

    values.forEach((value) => {
      const array = map[value];
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    });

    const wordsToPages = [];
    new Array(7).fill(0).forEach(() => {
      wordsToPages.push([]);
    });

    values.forEach((value) => {
      new Array(7).fill(0).forEach((_, index) => {
        const D = map[value].find((word) => word.style === "D");
        const I = map[value].find((word) => word.style === "I");
        const S = map[value].find((word) => word.style === "S");
        const C = map[value].find((word) => word.style === "C");

        map[value] = map[value].filter((word) => word.wordID !== D.wordID);
        map[value] = map[value].filter((word) => word.wordID !== I.wordID);
        map[value] = map[value].filter((word) => word.wordID !== S.wordID);
        map[value] = map[value].filter((word) => word.wordID !== C.wordID);

        const wordsToPagesNonFull = [];
        wordsToPages.forEach((arr, arrIndex) => {
          if (arr.length < 7) wordsToPagesNonFull.push(arrIndex);
        });
        const randomNumber = Math.floor(
          Math.random() * wordsToPagesNonFull.length
        );

        const discArray = [D, I, S, C];
        for (let i = discArray.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [discArray[i], discArray[j]] = [discArray[j], discArray[i]];
        }

        wordsToPages[wordsToPagesNonFull[randomNumber]].push(discArray);
      });
    });

    setWords(wordsToPages);
    setPage(0);
  };

  const finalPhase = () => {
    let finalWords = [];
    result.forEach((pageArr) => {
      pageArr.forEach((sectionArr) => {
        finalWords.push(sectionArr[0]);
      });
    });

    console.log({ finalWords });

    const values = ["REG", "THE", "AES", "ECO", "IND", "ALT", "POL"];
    const letters = ["D", "I", "S", "C"];

    const finalSections = [];
    for (let i = 0; i <= 6; i++) {
      // eslint-disable-next-line no-loop-func
      values.forEach((value) => {
        let newWord = null;
        letters.forEach((letter) => {
          if (newWord) return;
          newWord = finalWords.find(
            (word) => word.value === value && word.style === letter
          );
        });
        console.log({ newWord, arr: finalSections[i] });
        if (!finalSections[i]) finalSections[i] = [];
        finalWords = finalWords.filter(
          (word) => word?.wordID !== newWord?.wordID
        );
        finalSections[i].push(newWord);
      });
    }

    finalSections.forEach((fS) => {
    const array = fS;
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    });

    console.log({finalSections});

    words.push(finalSections);
    setWords(words);
    setPage(7);
  };

  const nextPage = (results = []) => {
    if (page === "welcome") {
      setPage(0);
    }
    if (typeof page === "number" && page <= 6) {
      for (let resultArr of results) {
        if (resultArr.includes(0)) {
          alert(lang_texts[lang].WARNING);
          return;
        }
      }
      window.scrollTo(0, 0);
      result.push(results);
      setResult(result);
      if (page < 6) setPage(page + 1);
    }
    if (page === 6) {
      finalPhase();
    }
    if (page === 7) {
      result.push(results);
      setResult(result);
      setPage("goodbye");
    }
    window.scrollTo(0, 0);
  };

  const submit = async (e) => {
    e.preventDefault();

    if (disableSubmit) return;
    setDisableSubmit(true);
    const values = ["IND", "AES", "ECO", "POL", "ALT", "THE", "REG"];
    const firstPhaseTextResult = {"REG": [], "THE": [], "AES": [], "ECO": [], "IND": [], "ALT": [], "POL": []};
    const lastPhaseTextResult = [[], [], [], [], [], [], []];

    for (let i = 0; i <= 6; i++) {
      const pageArr = result[i];
      pageArr.forEach((sectionArr) => {
        if (!sectionArr[0]?.value) return;
        const D = sectionArr.findIndex((word) => word.style === "D");
        const I = sectionArr.findIndex((word) => word.style === "I");
        const S = sectionArr.findIndex((word) => word.style === "S");
        const C = sectionArr.findIndex((word) => word.style === "C");
        console.log({sectionArr, D, I, S, C});
        const resultArr = [
          ["D", sectionArr[D]?.text, D+1],
          ["I", sectionArr[I]?.text, I+1],
          ["S", sectionArr[S]?.text, S+1],
          ["C", sectionArr[C]?.text, C+1],
        ];
        firstPhaseTextResult[sectionArr[0].value].push(resultArr);
      });
    }

    result[7].forEach((lastSectionArr, index) => {
      values.forEach((value) => {
        const wordForValueIndex = lastSectionArr.findIndex((word) => word.value === value);
        if (wordForValueIndex === -1) return;
        lastPhaseTextResult[index].push([value, lastSectionArr[wordForValueIndex].text, wordForValueIndex + 1]);
      });
    });

    console.log({firstPhaseTextResult, lastPhaseTextResult, name, email});
    await apiService.sendResults({ firstPhaseTextResult, lastPhaseTextResult, name, email });
    setDone(true);

    console.log({ name, email, result });
  };

  return (
    <div className="App">
      <header className="header">
        <img src={logo} alt="Logo" height={40} />
      </header>
      {typeof page === "number" && (
        <DragAndDropScreen
          page={page}
          words={words}
          rawWords={rawWords}
          nextPage={nextPage}
        />
      )}
      {page === "goodbye" && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            marginTop: 45,
          }}
          >
          {!done ? 
          <>
          <p
            style={{
              fontSize: 20,
              color: "black",
              fontWeight: 500,
              marginTop: 42,
              textAlign: "center",
            }}
          >
            {lang_texts[lang].LAST_PHASE}
          </p>
          <form>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>{lang_texts[lang].NAME}:</label>
              <input
                type="text"
                onChange={(e) => {
                  setName(e.target.value);
                }}
              ></input>
              <label style={{ marginTop: 12 }}>{lang_texts[lang].EMAIL}:</label>
              <input
                type="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              ></input>
            </div>
            <button className={"button"} onClick={(e) => submit(e)}>
              {lang_texts[lang].SUBMIT}
            </button>
          </form>
          </> :  <p
            style={{
              fontSize: 20,
              color: "black",
              fontWeight: 500,
              marginTop: 42,
              textAlign: "center",
            }}
          >
            {lang_texts[lang].GOODBYE}
          </p>
            }
        </div>
      )}
    </div>
  );
}

export default App;
